<div
  *ngIf="showError || showErrorTime || showErrorCustomForm"
  style="padding-left: 5%; padding-right: 5%"
  class="pb-2 mobile-error"
>
  <app-error-message
    *ngIf="showError"
    [message]="'choose-ticket-first' | translate"
    (dismissed)="showError = false"
  ></app-error-message>
  <app-error-message
    *ngIf="showErrorTime"
    (dismissed)="showErrorTime = false"
    [message]="'choose-time-error' | translate"
  ></app-error-message>
  <app-error-message
    *ngIf="showErrorCustomForm"
    (dismissed)="showErrorCustomForm = false"
    [message]="'custom-form-error' | translate"
  ></app-error-message>
</div>
<div class="d-flex justify-content-between book-footer">
  <div class="d-flex gap-1 align-items-center mobile-footer">
    <span
      *ngIf="ticketService.getTotalPriceInCart() != 0 && isMobile"
      class="total-amount"
      >{{ "total-price" | translate }} :
    </span>
    <button
      (click)="payNow()"
      class="btn"
      style="
        background-color: #FFC107;
        padding: 16px !important;
        border-radius: 10px !important;
        font-size: 16px;
        font-weight: 530 !important;
        color: white;
      "
    >
      <i
        *ngIf="translateService.currentLang == 'ar'"
        class="fa fa-arrow-right me-2"
      ></i>
      <i
        *ngIf="translateService.currentLang == 'en'"
        class="fa fa-arrow-left me-2"
      ></i>
      <span class="mx-1">
        {{ "continue-order" | translate }}
      </span>
    </button>
    <div *ngIf="ticketService.getTotalPriceInCart() != 0 && !isMobile">
      <span class="total-amount">{{ "total-price" | translate }} : </span>
      <span class="total-amount-value">
        <span
          [innerHTML]="
            ticketService.bookTicket.getValue()?.totalwithdiscount
              ? (ticketService.getTotalPriceInCart()
                | customCurrency : 'SAR' : 'symbol' : '#555770' : 33)
              : (ticketService.getTotalPriceInCart()
                | toVat
                | customCurrency : 'SAR' : 'symbol' : '#555770' : 33)
          "
        ></span>
      </span>
    </div>
  </div>
  <div class="d-flex mobile-footer" style="gap: 15px">
    <div
      class="total-amount-value"
      *ngIf="ticketService.getTotalPriceInCart() != 0 && isMobile"
    >
      <span
        [innerHTML]="
          ticketService.bookTicket.getValue()?.totalwithdiscount
            ? (ticketService.getTotalPriceInCart()
              | customCurrency : 'SAR' : 'symbol' : '#555770' : 30)
            : (ticketService.getTotalPriceInCart()
              | toVat
              | customCurrency : 'SAR' : 'symbol' : '#555770' : 30)
        "
      ></span>
    </div>

    <div (click)="cancel()" class="d-flex gap-1 cancel align-items-center">
      <i class="fa fa-close"></i>
      <span style="font-weight: 700"> {{ "cancel-reserve" | translate }} </span>
    </div>
  </div>
</div>
